import { api } from './api';

export async function submitFeedback(serviceId, payload) {
  return api.post(`/api/driver/services/${serviceId}/feedback`, payload);
} 